import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import "./css/AboutSection.css";

import img1 from "../media/about1.png";
import img2 from "../media/about2.png";
import img4 from "../media/about4.png";

export default function AboutSection() {
  const { t } = useLanguage();

  // Local slides array
  const slides = [
    {
      image: img1,
      text: t("about.slide1"),
    },
    {
      image: img2,
      text: t("about.slide2"),
    },
    {
      image: img4,
      text: t("about.slide3"),
    },
  ];

  // Local state for carousel index
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="about-section" id="about">
      <h2 className="about-title">{t("about.title")}</h2>
      <p className="about-subtitle">
        {t("about.subtitle")}
      </p>

      <div className="about-carousel">
        {/* IMAGE VIEWPORT */}
        <div className="about-viewport">
          <div
            className="about-slider about-image-slider"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {slides.map((slide, i) => (
              <div className="about-slide" key={`img-${i}`}>
                <div className="about-image-container">
                  <img
                    src={slide.image}
                    alt={t("about.imageAlts", [])[i] || ""}
                    className="about-image"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* TEXT VIEWPORT */}
        <div className="about-viewport">
          <div
            className="about-slider about-text-slider"
            style={{ transform: `translateX(${currentIndex * 100}%)` }} // <-- no minus
          >
            {slides.map((slide, i) => (
              <div className="about-slide" key={`txt-${i}`}>
                <div className="about-text-container">
                  <p className="about-text">{slide.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="about-controls">
        <button className="arrow-btn" onClick={prevSlide} aria-label="Previous">
          &lt;
        </button>
        <button className="arrow-btn" onClick={nextSlide} aria-label="Next">
          &gt;
        </button>
      </div>

      <p className="about-footer">
        {t("about.footer")}
      </p>
    </section>
  );
}
